import { render, staticRenderFns } from "./CheckboxGroup.vue?vue&type=template&id=bf035472&scoped=true&"
import script from "./CheckboxGroup.vue?vue&type=script&lang=js&"
export * from "./CheckboxGroup.vue?vue&type=script&lang=js&"
import style0 from "./CheckboxGroup.vue?vue&type=style&index=0&id=bf035472&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf035472",
  null
  
)

export default component.exports